/* ------------------------------ */
/* Slide Fade Toggle */
/* ------------------------------ */

$.fn.slideFadeToggle  = function (speed, easing, callback) {
    return this.animate({opacity: 'toggle', height: 'toggle'}, speed, easing, callback);
};